import { CircularProgress } from '@mui/material'
import React from 'react'

const MySpiner = () => {
  return (
    <p 
        style={{
            display:'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}
    >
        <CircularProgress
            color="secondary" 
            sx={{
                color: '#FF9A57',                            
                marginBottom: '20px'
            }} 
        />
    </p>
  )
}

export default MySpiner